import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=8e0ff72e&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=8e0ff72e&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e0ff72e')) {
      api.createRecord('8e0ff72e', component.options)
    } else {
      api.reload('8e0ff72e', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=8e0ff72e&", function () {
      api.rerender('8e0ff72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Waste/Form.vue"
export default component.exports